import React from "react";
import Dummy from "./components/Register-Dummy";
import './css/register.css';

function Register(){
    return(
        <>
        <div className="container">
            <div className="row">
                <Dummy />
            </div>
        </div>
        </>
    )
}

export default Register;
